// 1. Create proper custom history with state management
import { createBrowserHistory } from 'history';
// 2. Create a wrapper component to manage history state
import { useState, useLayoutEffect } from 'react';
import { Router } from 'react-router-dom';

export const history = createBrowserHistory();
let preservedHash = history.location.hash;

// Store initial hash on first load
const initialHash = history.location.hash;

// Override push/replace methods
const originalPush = history.push;
const originalReplace = history.replace;

history.push = (path, state) => {
  const pathObj = typeof path === 'string' ? { pathname: path } : path;
  return originalPush.call(
    history,
    {
      ...pathObj,
      hash: pathObj.hash || preservedHash,
    },
    state
  );
};

history.replace = (path, state) => {
  const pathObj = typeof path === 'string' ? { pathname: path } : path;
  return originalReplace.call(
    history,
    {
      ...pathObj,
      hash: pathObj.hash || preservedHash,
    },
    state
  );
};

export function HistoryRouter({ children }) {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => {
    return history.listen(setState);
  }, []);

  return (
    <Router
      navigator={history}
      location={state.location}
      navigationType={state.action}
      children={children}
    />
  );
}
